import { TransactionSteps } from 'interfaces/transaction';
import { Adapter } from 'utils/api';

import { prepare } from './helpers';
import { PostRegistrationRequest } from './types';

export default class RegistrationService {
  private adapter: Adapter;

  constructor(baseURL: string = process.env.REACT_APP_API_DOMAIN || '') {
    this.adapter = new Adapter({
      baseURL,
      headers: {
        timeout: 60 * 10 * 1000,
        'content-type': 'application/json',
        accept: 'application/json'
      }
    });
  }

  async submitPayload(data: TransactionSteps) {
    const payload = prepare(data);
    return await this.adapter.postValue<PostRegistrationRequest>('/construction/register', payload);
  }
}
